import React from 'react';
import { PapiDeviation } from '@wix/da-papi-types';
import DeviationDumbView from '../DeviationViews/Dumbo';
import DeviationLink from '../Duperbrowse/DeviationLink';

export interface Props {
  deviation: PapiDeviation | undefined;
  size: number;
  className?: string;
}

const PollOptionThumb: React.FC<Props> = ({ deviation, size }) => {
  return deviation ? (
    <DeviationLink deviation={deviation} target="_blank">
      <DeviationDumbView deviation={deviation} width={size} height={size} />
    </DeviationLink>
  ) : (
    // Deviation is inactive/deleted
    // Render an Unknown thumb (a "null" deviation) instead
    <DeviationDumbView deviation={{} as PapiDeviation} width={size} height={size} />
  );
};
PollOptionThumb.displayName = 'PollOptionThumb';

export default PollOptionThumb;
